import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, InputNumber } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { createAnalyzerItems, updateAnalyzerItems } from 'services/settings/lookup_table/analyzer';

const AnalyzerForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate }) => {
	console.log(selecetedData);

	const onFinish = async values => {
		console.log(values);

		const payload = {
			analyzerName: values.analyzerName,
			is_active: values.active === true ? 1 : 0,
		};

		console.log(payload);

		if (buttonNames === 'ADD') {
			const created = await createAnalyzerItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			payload.analyzerID = selecetedData.analyzerID;
			const updated = await updateAnalyzerItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					analyzerName: selecetedData ? selecetedData.analyzerName : '',
					active: selecetedData ? (selecetedData.active === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="active" valuePropName="checked">
							<Switch disabled={buttonNames === 'ADD'} />
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="ANALYZER NAME"
					name="analyzerName"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254}/>
				</Form.Item>
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default AnalyzerForm;
